import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLightbulb = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.75 18.625a.625.625 0 0 1-.625.625h-6.25a.625.625 0 1 1 0-1.25h6.25a.625.625 0 0 1 .625.625m3.125-10a6.84 6.84 0 0 1-2.628 5.407 1.27 1.27 0 0 0-.497 1v.468a1.25 1.25 0 0 1-1.25 1.25h-5a1.25 1.25 0 0 1-1.25-1.25v-.469a1.25 1.25 0 0 0-.487-.989 6.84 6.84 0 0 1-2.638-5.379c-.02-3.723 2.99-6.824 6.71-6.913a6.875 6.875 0 0 1 7.04 6.875m-1.25 0A5.626 5.626 0 0 0 9.865 3c-3.048.072-5.506 2.609-5.49 5.656a5.6 5.6 0 0 0 2.16 4.398 2.5 2.5 0 0 1 .965 1.977v.469h5v-.469a2.51 2.51 0 0 1 .974-1.98 5.6 5.6 0 0 0 2.151-4.426m-1.258-.73a4.5 4.5 0 0 0-3.638-3.636.625.625 0 1 0-.208 1.232c1.295.218 2.393 1.317 2.613 2.614a.625.625 0 0 0 1.233-.21"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLightbulb);
export default ForwardRef;
